export default interface TipoServicoModel {
    name:string;
    descricao:string;
}

export const tiposServicoList:TipoServicoModel[] = [
    { name: "BATERIA", descricao: "Carga de bateria" },
    { name: "CHAVEIRO", descricao: "Chaveiro" },
    { name: "TROCA_PNEU", descricao: "Troca de pneu" },
    { name: "GUINCHO", descricao: "Guincho" },
    { name: "TRANSPORTE_ASSOCIADO", descricao: "Transporte ao associado" },
    { name: "PATINS", descricao: "Patins" },
    { name: "HORA_TRABALHADA", descricao: "Hora Trabalhada" },
    { name: "HORA_PARADA", descricao: "Hora Parada" }
]
